export interface IUserSettings {
    // loginEmail: ILoginMethodState;
    loginEmails: ILoginMethodState[];
    // loginPhoneNumber: ILoginMethodState;
    loginPhoneNumbers: ILoginMethodState[];
    loginCertificate?: ILoginMethodState[]
    hasCqes?: boolean
}

export interface ILoginMethodState {
    value: string;
    status?: LoginMethodStatus;
    expTimestamp?: number;
    id?: number;
}

export enum LoginMethodStatus {
    active = 'ACTIVE',
    inactive = 'INACTIVE'// Изпратена, но непотвърдена заявка за регистрация
}

export enum LoginType {
    'email',
    'phone',
    'certificate'
}

export enum LoginMethodAction {
    'add',
    'update'
}

export enum SearchUserIdentifiers {
    email = 'email',
    phoneNumber = 'phoneNumber',
    personalId = 'personalId',
}

export type SearchUserRequestParams = {
    email?: string;
    phoneNumber?: string;
    personalId?: string;
    isCopy?: boolean;
    companyCmrId?: string;
};
